import config from "../../../config";
import sendRequest from "../../../helpers/requestHelper";
import eventBus from "../../../event-bus/eventBus";

const getCalculations = {
    namespaced: true,
    state: {
        calculationsTableHeaders: [],
        calculationDriveCostsTableHeaders: [],
        calculationMaterialCostsTableHeaders: [],
        calculationWorkCostsTableHeaders: [],
        pagination: {
            page: 1,
            rowsPerPage: 20,
            totalItems: null,
            sortBy: [""],
            sortDesc: [""],
            current: 1
        },
        loadingCalculations: false,
        calculations: []
    },
    mutations: {
        GET_CALCULATIONS_SUCCESS(state, response) {
            state.calculations = response.data.data;
            if(response.data.meta !== undefined) {
                state.pagination.page = response.data.meta.current_page;
                state.pagination.rowsPerPage = response.data.meta.per_page;
                state.pagination.totalItems = response.data.meta.total;
            }
        },
        GET_CALCULATIONS_FAILURE(state, error) {
            console.log(error);
            state.calculations = [];
        },
        GET_CALCULATIONS_TABLE_HEADERS_SUCCESS(state, response) {
            response.data.forEach(el => el.class = "table-headers");
            state.calculationsTableHeaders = response.data;
        },
        GET_CALCULATIONS_TABLE_HEADERS_FAILURE(state, error) {
            console.log(error);
        },
        GET_CALCULATION_DRIVE_COSTS_TABLE_HEADERS_SUCCESS(state, response) {
            response.data.forEach(el => el.class = "table-headers");
            state.calculationDriveCostsTableHeaders = response.data;
        },
        GET_CALCULATION_DRIVE_COSTS_TABLE_HEADERS_FAILURE(state, error) {
            console.log(error);
        },
        GET_CALCULATION_MATERIAL_COSTS_TABLE_HEADERS_SUCCESS(state, response) {
            response.data.forEach(el => el.class = "table-headers");
            state.calculationMaterialCostsTableHeaders = response.data;
        },
        GET_CALCULATION_MATERIAL_COSTS_TABLE_HEADERS_FAILURE(state, error) {
            console.log(error);
        },
        GET_CALCULATION_WORK_COSTS_TABLE_HEADERS_SUCCESS(state, response) {
            response.data.forEach(el => el.class = "table-headers");
            state.calculationWorkCostsTableHeaders = response.data;
        },
        GET_CALCULATION_WORK_COSTS_TABLE_HEADERS_FAILURE(state, error) {
            console.log(error);
        },
    },
    actions: {
        getCalculationsRequest: function({dispatch, state}, payload={}) {
            let queryParams = {};

            let page_number = payload.page || state.pagination.page;
            let rowsPerPage = payload.itemsPerPage || state.pagination.rowsPerPage;
            let sortDesc = payload.sortDesc || state.pagination.sortDesc;
            let sortBy = (payload.sortBy !== undefined && payload.sortBy.length !== 0) ? payload.sortBy : state.pagination.sortBy;
            let language = payload.language;
            let current_page = payload.filters === true ? 1 : null;
            let search = payload.search;

            queryParams = {
                page: page_number,
                rowsPerPage: rowsPerPage,
                language,
                sortBy: sortBy[0],
                sortDesc: sortDesc[0],
                current_page,
                search
            };

            state.pagination.sortBy = sortBy;
            state.pagination.sortDesc = sortDesc;

            let calculationsURL  = config.baseURLApi + "/calculations";
            state.loadingCalculations = true;
            eventBus.$emit("setDisablePagination", true);

            let promise = sendRequest("get", calculationsURL, {}, {}, true, queryParams);
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successGetCalculations", result[1]);
                } else {
                    dispatch("failureGetCalculations", result[1]);
                }
                state.loadingCalculations = false;
                eventBus.$emit("setDisablePagination", false);
            });
        },
        successGetCalculations: function({commit}, response) {
            commit("GET_CALCULATIONS_SUCCESS", response);
        },
        failureGetCalculations: function({commit}, error) {
            commit("GET_CALCULATIONS_FAILURE", error);
        },
        getCalculationsHeadersTableRequest: function({dispatch}) {
            var promise = sendRequest("get", config.baseURLApi + "/calculations/tableHeaders/getCalculationsTableHeaders", {});
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successGetCalculationsTableHeaders", result[1]);
                } else {
                    dispatch("failureGetCalculationsTableHeaders", result[1]);
                }
            });
        },
        successGetCalculationsTableHeaders: function({commit}, response) {
            commit("GET_CALCULATIONS_TABLE_HEADERS_SUCCESS", response);
        },
        failureGetCalculationsTableHeaders: function({commit}, error) {
            commit("GET_CALCULATIONS_TABLE_HEADERS_FAILURE", error);
        },

        getCalculationDriveCostsHeadersTableRequest: function({dispatch}) {
            var promise = sendRequest("get", config.baseURLApi + "/calculations/tableHeaders/getCalculationDriveCostsTableHeaders", {});
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successGetCalculationDriveCostsTableHeaders", result[1]);
                } else {
                    dispatch("failureGetCalculationDriveCostsTableHeaders", result[1]);
                }
            });
        },
        successGetCalculationDriveCostsTableHeaders: function({commit}, response) {
            commit("GET_CALCULATION_DRIVE_COSTS_TABLE_HEADERS_SUCCESS", response);
        },
        failureGetCalculationDriveCostsTableHeaders: function({commit}, error) {
            commit("GET_CALCULATION_DRIVE_COSTS_TABLE_HEADERS_FAILURE", error);
        },

        getCalculationMaterialCostsHeadersTableRequest: function({dispatch}) {
            var promise = sendRequest("get", config.baseURLApi + "/calculations/tableHeaders/getCalculationMaterialCostsTableHeaders", {});
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successGetCalculationMaterialCostsTableHeaders", result[1]);
                } else {
                    dispatch("failureGetCalculationMaterialCostsTableHeaders", result[1]);
                }
            });
        },
        successGetCalculationMaterialCostsTableHeaders: function({commit}, response) {
            commit("GET_CALCULATION_MATERIAL_COSTS_TABLE_HEADERS_SUCCESS", response);
        },
        failureGetCalculationMaterialCostsTableHeaders: function({commit}, error) {
            commit("GET_CALCULATION_MATERIAL_COSTS_TABLE_HEADERS_FAILURE", error);
        },

        getCalculationWorkCostsHeadersTableRequest: function({dispatch}) {
            var promise = sendRequest("get", config.baseURLApi + "/calculations/tableHeaders/getCalculationWorkCostsTableHeaders", {});
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successGetCalculationWorkCostsTableHeaders", result[1]);
                } else {
                    dispatch("failureGetCalculationWorkCostsTableHeaders", result[1]);
                }
            });
        },
        successGetCalculationWorkCostsTableHeaders: function({commit}, response) {
            commit("GET_CALCULATION_WORK_COSTS_TABLE_HEADERS_SUCCESS", response);
        },
        failureGetCalculationWorkCostsTableHeaders: function({commit}, error) {
            commit("GET_CALCULATION_WORK_COSTS_TABLE_HEADERS_FAILURE", error);
        },
    }
}

export default getCalculations;